import React from "react";
import PresupuestoArt from "./PresupuestoArt";
import AuthCarousel from "./AuthCarousel";

/** Lo que el sistema hace, dicho desde el lado de quien lo usa. */
const SLIDES = [
  {
    titulo: "Presupuestos que cuadran",
    texto:
      "Arma el presupuesto por niveles, del padre a cada partida, y ve el total actualizarse solo.",
  },
  {
    titulo: "Proveedores en orden",
    texto:
      "Comparte un formulario, recibe sus datos y genera el contrato sin volver a capturar nada.",
  },
  {
    titulo: "Cada pago con su fecha",
    texto:
      "Programa las fechas de pago de cada partida y lleva el control de lo que ya se cubrió.",
  },
];

export default function AuthShowcase() {
  return (
    <aside className="auth-showcase">
      <PresupuestoArt className="auth-art" />
      <AuthCarousel slides={SLIDES} />
    </aside>
  );
}
